import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M20.047 8h-8.124c-.8 0-1.423.917-1.423 2h11c0-1.083-.652-2-1.453-2zM23.311 12.736c-.059-.984-.89-1.736-1.898-1.736h-10.8c-1.008 0-1.839.752-1.898 1.736l-.712 10.268A1.9 1.9 0 0 0 9.902 25h12.193c1.098 0 1.988-.926 1.899-1.996l-.683-10.268zm-7.298 5.756c-2.403 0-4.361-1.91-4.361-4.223 0-.26.208-.463.475-.463s.474.202.474.463c0 1.822 1.513 3.268 3.383 3.268 1.869 0 3.382-1.475 3.382-3.268 0-.26.207-.463.474-.463s.475.202.475.463c.06 2.343-1.899 4.223-4.302 4.223z"
})), 'ShoppingBag', {
  viewBox: '4 4 24 24'
});